import React, { useEffect, useMemo, useState } from 'react';
import Picker from 'react-mobile-picker';
import { checkIsIOS } from '../../utill.func';
import commonConstant,
{
  LABEL_DOB_PICKER_CANCEL,
  LABEL_DOB_PICKER_HEADING,
  LABEL_DOB_PICKER_SUBMIT
} from '../commonConstant';
import "./DOBPicker.scss";

const DOBPicker = ({
  onClose,
  onSubmit,
  onDelete,
  defaultValue = {
    day: `${new Date().getDate()}`,
    month: commonConstant.MONTHS.th[new Date().getMonth()],
    year: new Date().getFullYear()
  },
  disabled,
  onChange,
  isOpen,
  isThai,
  pickerHeader,
  modalHeight,
  pickerHeight = modalHeight && modalHeight - 100,
  showSelected = true,
  disableFutureDates = false,
}) => {


  const defaultDateStart = new Date(new Date().setHours(0, 0, 0, 0));
  const defaultDateEnd = new Date(new Date().setHours(23, 59, 59, 999));

  const getMonthDays = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  }

  const [pickerValue, setPickerValue] = useState(defaultValue);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleTouchMove = (e) => {
      const picker = e.target.closest('.dob-modal-picker-wrapper');
      if (!picker) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isOpen]);

  const selections = useMemo(() => {
    const RELEASE_DATE = new Date('1924-01-01');

    const YearRange = Array.from(
      { length: defaultDateEnd.getFullYear() - RELEASE_DATE.getFullYear() + 1 },
      (_, index) => new Date(RELEASE_DATE.getFullYear() + index, 0).getFullYear()
    );

    const selectedYear = pickerValue.year || defaultDateStart.getFullYear();
    const selectedMonth = isThai ? commonConstant.MONTHS.th.indexOf(pickerValue.month) : commonConstant.MONTHS.en.indexOf(pickerValue.month);

    return {
      day: Array.from({ length: getMonthDays(selectedYear, selectedMonth) }, (_, i) => `${i + 1}`),
      month: isThai ? commonConstant.MONTHS.th : commonConstant.MONTHS.en,
      year: YearRange,
    };
  }, [pickerValue.year, pickerValue.month]);

  const HandlePickerChange = (...obj) => {
    setPickerValue(...obj);
    onChange && onChange(...obj);
  }

  const isFutureDate = disableFutureDates && new Date(pickerValue.year, commonConstant.MONTHS.th.indexOf(pickerValue.month), pickerValue.day) >= new Date(new Date().setHours(0, 0, 0, 0));

  const handleSubmit = () => {
    if (isFutureDate) return;
    const dateValue = new Date(`${pickerValue.year}`, commonConstant.MONTHS.th.indexOf(pickerValue.month), pickerValue.day);
    onSubmit && dateValue.getTime() && onSubmit(dateValue);
  }
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? '--no_scroll' : ''}`} onClick={onClose}>
      <div className={`dob-modal ${checkIsIOS() ? '--ios' : '--android'}`} onClick={(e) =>  e.stopPropagation()}>
        <div className="dob-modal-header">
          <span className="dob-modal-heading">{LABEL_DOB_PICKER_HEADING}</span>
          <img src="/images/Close.svg" className="dob-modal-close" onClick={onClose} />
        </div>

        <Picker value={pickerValue} onChange={HandlePickerChange} height={pickerHeight} itemHeight={62.33} className={`dob-modal-picker-wrapper${disabled ? ' --disabled' : ''}`}>
          {Object.keys(selections).map(name => (
            <Picker.Column key={name} name={name} className='dob-modal-picker-column'>
              {selections[name].map(option => (
                <Picker.Item key={option} value={option}>
                  {({ selected }) => (

                    <div className={`dob-modal-picker-item${selected && showSelected ? ' --selected' : ''}`}>
                      {option}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
          ))}
        </Picker>

        <div className="dob-modal-actions">
          <button onClick={handleSubmit} type="button" className="btn-submit" disabled={isFutureDate}>{LABEL_DOB_PICKER_SUBMIT}</button>
          <button onClick={onDelete} type="button" className="btn-delete">{LABEL_DOB_PICKER_CANCEL}</button>
        </div>
      </div>
    </div>
  );
};

export default DOBPicker;